export interface Expertise {
  title: string;
  description: string;
}

export const expertise: Expertise[] = [
  { title: 'Solution Architecture', description: 'Designing enterprise-grade systems on the Microsoft stack, from data model to deployment topology, with front-end architecture oversight across React, Angular, and Blazor' },
  { title: 'Legacy Modernization', description: 'Assessing legacy government and enterprise estates, exposing risk, and phasing migrations to modern .NET without breaking the business' },
  { title: 'Geospatial (GIS) Platforms', description: 'Architecting spatial data platforms on Esri ArcGIS, PostGIS, and vector tiles at scale' },
  { title: 'Workflow Orchestration', description: 'Externalizing business process logic with Camunda 8 BPMN so rules change without a release' },
  { title: 'API Security & Digital Payments', description: 'Building OWASP-aligned APIs and services for digital wallets, KYC, and payment platforms' },
  { title: 'Technical Leadership & Standards', description: 'Setting engineering standards, code review practice, and the technical hiring bar across delivery teams' },
];
